import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from '@progress/kendo-intl';
import * as React from 'react';
import { ViewModel } from '.';

const DistanceCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps} style={{ ...props.tdProps?.style, textAlign: 'right' }}>
      {formatNumber(data.LoadedMiles, 'n0')}<br />
      Out: {formatNumber(data.ETAMiles, 'n0')}
    </td>
  );
}
export default React.memo(DistanceCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);